import "./App.css";
import { BrowserRouter } from "react-router-dom";
import Routes from "./routes";
import { CredentialsProvider } from "./common/CredentialsContext";
import { TokenProvider } from "./common/TokenContext";
import { AuthProvider } from "./auth/authContext";
import AuthGuard from "./auth/authGuard";

function App() {
  return (
    <BrowserRouter>
      <CredentialsProvider>
        <TokenProvider>
          <AuthProvider>
            <AuthGuard>
              <Routes />
            </AuthGuard>
          </AuthProvider>
        </TokenProvider>
      </CredentialsProvider>
    </BrowserRouter>
  );
}

export default App;
